var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-11,.cls-14,.cls-15,.cls-16,.cls-19{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#00001d;}.cls-4{fill:#0d2443;}.cls-5{fill:#00002d;}.cls-13,.cls-18,.cls-6,.cls-7,.cls-8{fill:#f3ddce;}.cls-6{opacity:0.25;}.cls-17,.cls-7{opacity:0.5;}.cls-8{opacity:0.75;}.cls-9{fill:#0e3157;}.cls-10{fill:#194b83;}.cls-11,.cls-14,.cls-15{stroke:#0e3157;}.cls-11,.cls-14,.cls-15,.cls-16,.cls-19{stroke-miterlimit:10;}.cls-12{fill:#1c4a7d;}.cls-14{stroke-width:0.5px;}.cls-15{stroke-width:0.8px;}.cls-16{stroke:#1c4a7d;}.cls-18{opacity:0.1;}.cls-19{stroke:#171c61;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 192,
    height: 100,
    transform: "translate(192 100) rotate(-180)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4E00\\u822C\\u5716\\u5F62"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 192,
    height: 100,
    transform: "translate(192 100) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 20.28,
    y: 74.01,
    width: 2.07,
    height: 1.08,
    rx: 0.27,
    transform: "translate(42.62 149.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 14.39,
    y: 74.3,
    width: 1.75,
    height: 0.79,
    rx: 0.22,
    transform: "translate(30.52 149.39) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4.47,
    y: 74.01,
    width: 2.37,
    height: 1.08,
    rx: 0.29,
    transform: "translate(11.32 149.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 32.87,
    y: 74.3,
    width: 2.07,
    height: 1.08,
    rx: 0.27,
    transform: "translate(67.8 149.68) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.28,66.09v9.25H88V66.09Zm.37.65h2v1.07h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.75,66.09v9.25h2.76V66.09Zm.38.6h2v1.06h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78.14,66.09v9.25h2.75V66.09Zm.37.6h2v1.06h-2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.83,
    y: 72.97,
    width: 4.41,
    height: 2.36,
    transform: "translate(176.07 148.31) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 64.64,
    y: 72.87,
    width: 3.27,
    height: 1.62,
    transform: "translate(132.55 147.37) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.06,75.34h4.42V73.2l-1.17-1.58H65l-.91,1.23Zm2.78-2.09h1v.87h-1Zm-2.15.87v-.87h1v.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.35,75.34h4.42V73.2L57.6,71.62H55.26l-.91,1.23Zm2.77-2.09h1.05v.87H57.12ZM55,74.12v-.87H56v.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 57.32,
    y: 73.27,
    width: 2.92,
    height: 1.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.11,73.35v2h3.35V73l0,0-.61-.58H58Zm2.15.22H60V74h-.74Zm-1.64,0h.74V74h-.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 76.82,
    y: 65.05,
    width: 5.08,
    height: 13.91,
    transform: "translate(151.37 -7.35) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M71.36,68.69v6.65H87.67V68.69ZM79.3,71.2H76.41V69.74H79.3Zm.42-1.46h3V71.2h-3ZM86,71.2H83.13V69.74H86ZM73.06,69.74H76V71.2H73.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 60.46,
    y: 63.25,
    width: 5.04,
    height: 9.58,
    transform: "translate(125.96 136.07) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 95.41,
    y: 57.09,
    width: 6.56,
    height: 16.64,
    transform: "translate(197.38 130.81) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 110.88,
    y: 39.57,
    width: 9.34,
    height: 27.45,
    transform: "translate(231.1 106.58) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 132.55,
    y: 39.48,
    width: 5.62,
    height: 25.79,
    transform: "translate(270.72 104.75) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 154.79,
    y: 65.48,
    width: 5.84,
    height: 0.78,
    transform: "translate(315.43 131.74) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 154.47,
    y: 66.26,
    width: 5.99,
    height: 0.14,
    transform: "translate(314.93 132.66) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 154.39,
    y: 61.3,
    width: 5.84,
    height: 0.78,
    transform: "translate(314.62 123.38) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 154.07,
    y: 62.08,
    width: 5.99,
    height: 0.14,
    transform: "translate(314.12 124.3) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 173.21,
    y: 63.12,
    width: 5.44,
    height: 9.73,
    transform: "translate(351.86 135.96) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 184.96,
    y: 61.04,
    width: 6.76,
    height: 11.19,
    transform: "translate(376.68 133.27) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 163.19,
    y: 66.52,
    width: 4.66,
    height: 7.18,
    transform: "translate(331.05 140.23) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M162.78,66.79V75.2a.15.15,0,0,0,.16.14h4.71a.15.15,0,0,0,.15-.14V62.75c0-.12-.16-.17-.26-.09l-4.71,4A.11.11,0,0,0,162.78,66.79Zm3.14,1.09h-.63v-.55h.63Zm0,1.31H164v-.55h1.88Zm0,1.32h-1.25V70h1.25Zm0,1.31h-.63v-.56h.63Zm.63.75h.63v.56h-.63Zm0-1.31h.63v.56h-.63Zm0-1.31h.63v.56h-.63Zm0-1.31h.63v.55h-.63Zm0-1.31h.63v.55h-.63ZM164,72.57h1.88v.56H164Zm-.63-1.31h1.26v.56h-1.26Zm0-1.31H164v.56h-.63Zm0-2.62h1.26v.55h-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M95.13,49v26.1a.28.28,0,0,0,.28.28H104a.28.28,0,0,0,.28-.28V57.43a.28.28,0,0,0-.08-.2L95.6,48.77A.28.28,0,0,0,95.13,49ZM102,58h.91v15H102Zm-1.82,0h.91v15h-.91Zm-1.83,0h.91v15h-.91ZM96.5,58h.91v15H96.5Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 110.88,
    y1: 39.22,
    x2: 110.88,
    y2: 66.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.59,66.13V64.94a.17.17,0,0,0-.17-.16h-9.86a.16.16,0,0,1-.16-.16V62.83a.16.16,0,0,1,.16-.16h9.86a.17.17,0,0,0,.17-.16V61.32a.17.17,0,0,0-.17-.16h-9.86a.16.16,0,0,1-.16-.16V59.21a.16.16,0,0,1,.16-.16h9.86a.17.17,0,0,0,.17-.15V57.7a.17.17,0,0,0-.17-.16h-9.86a.16.16,0,0,1-.16-.15v-1.8a.16.16,0,0,1,.16-.15h9.86a.17.17,0,0,0,.17-.16v-1.2a.17.17,0,0,0-.17-.16h-9.86a.16.16,0,0,1-.16-.15V52a.16.16,0,0,1,.16-.15h9.86a.17.17,0,0,0,.17-.16v-1.2a.17.17,0,0,0-.17-.15h-9.86a.16.16,0,0,1-.16-.16V48.36a.16.16,0,0,1,.16-.16h9.86a.17.17,0,0,0,.17-.16V46.85a.17.17,0,0,0-.17-.16h-9.86a.16.16,0,0,1-.16-.16V44.74a.16.16,0,0,1,.16-.16h9.86a.17.17,0,0,0,.17-.16V43.23a.17.17,0,0,0-.17-.16h-9.86a.16.16,0,0,1-.16-.16V41.67a.16.16,0,0,1,.16-.16h9.86a.17.17,0,0,0,.17-.16v-1.2a.17.17,0,0,0-.17-.15h-9.86a.16.16,0,0,1-.16-.16V38.37a.16.16,0,0,1,.16-.16h12.33a.16.16,0,0,1,.16.16V75.18a.16.16,0,0,1-.16.16H109.56a.16.16,0,0,1-.16-.16V66.45a.16.16,0,0,1,.16-.16h9.86A.17.17,0,0,0,119.59,66.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M131.4,38.17v36.6c0,.31.17.57.37.57h6.92c.2,0,.37-.26.37-.57V38.17c0-.31-.17-.57-.37-.57h-.18a4.88,4.88,0,0,0-1.37-3.49V32.53c0-.06,0-.1-.06-.1h-1.49l-.31-4.58c0-.1-.09-.1-.1,0l-.31,4.58h-1.49s-.06,0-.06.1v1.58A4.88,4.88,0,0,0,132,37.6h-.18C131.57,37.6,131.4,37.86,131.4,38.17Zm1.15,24.25h5.36v1.25h-5.36Zm0-2.48h5.36v1.24h-5.36Zm0-2.44h5.36v1.25h-5.36Zm0-2.43h5.36v1.25h-5.36Zm0-2.48h5.36v1.24h-5.36Zm0-2.49h5.36v1.24h-5.36Zm0-2.43h5.36v1.24h-5.36Zm0-2.43h5.36v1.24h-5.36Zm0-2.49h5.36V44h-5.36Zm0-2.49h5.36v1.25h-5.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "159.63 54.63 159.63 55.48 163.54 55.48 163.54 54.63 164.21 54.63 164.21 75.34 158.97 75.34 158.97 54.63 159.63 54.63"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 154.03,
    y: 64.67,
    width: 14.49,
    height: 0.63,
    transform: "translate(96.29 226.26) rotate(-90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "162.85 57.74 163.47 57.74 163.47 72.23 162.85 72.23 162.22 72.23 162.22 57.74 162.85 57.74"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 152.77,
    y: 64.67,
    width: 14.49,
    height: 0.63,
    transform: "translate(95.03 225) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M184.58,60.21V75.34H192V60.21h-.94V58.53h-1.23V57.46h-3.09v1.07h-1.22v1.68ZM185.35,71h5.87V72h-5.87Zm0-1.89h5.87v.94h-5.87Zm0-1.9h5.87v1h-5.87Zm0-1.89h5.87v1h-5.87Zm0-1.76h5.87v.94h-5.87Zm0-1.9h5.87v.95h-5.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M172.86,62.47V75.34h5.57V62.47h-.71V61h-.91v-.9h-2.33V61h-.91v1.44Zm.58,9.21h4.41v.81h-4.41Zm0-1.61h4.41v.81h-4.41Zm0-1.61h4.41v.8h-4.41Zm0-1.61h4.41v.8h-4.41Zm0-1.5h4.41v.8h-4.41Zm0-1.62h4.41v.81h-4.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 67.69,
    y: 61.64,
    width: 6.67,
    height: 10.82,
    transform: "translate(142.06 134.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 89.29,
    y: 61.97,
    width: 6.62,
    height: 10.49,
    transform: "translate(185.19 134.44) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 101.71,
    y: 45.43,
    width: 9.94,
    height: 23.61,
    transform: "translate(213.36 114.47) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 119.42,
    y: 45.95,
    width: 13.59,
    height: 23.64,
    transform: "translate(252.44 115.55) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 137.04,
    y: 49.37,
    width: 11.64,
    height: 20.34,
    transform: "translate(285.71 119.07) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 178.65,
    y: 57.46,
    width: 8.89,
    height: 7.22,
    transform: "translate(366.18 122.14) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M118.44,45.4h0V75.15a.21.21,0,0,0,.22.19h14.92a.2.2,0,0,0,.21-.19V45.41h0c-.37-5.56-5.5-10-11.79-10v9.79h0V35.44c-1.9,0-3.45,4.4-3.56,10ZM122,52.49h-1.84V50.68H122Zm2.77-3.62h-1.85v-1.8h1.85Zm1.84,1.81v1.81h-3.69V50.68Zm2.76-1.81h-3.68v-1.8h3.68Zm0,3.62h-1.84V50.68h1.84Zm2.77-3.62h-1.85v-1.8h1.85Zm0,3.62h-1.85V50.68h1.85Zm-12,12.66h12V67h-12Zm0-3.62h12v1.81h-12Zm0-3.61h12v1.8h-12Zm0-3.62h12v1.81h-12Zm0-7.23H122v1.8h-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M67.31,61.08V75.34h7.42V61.08h-.94V59.5H72.57v-1h-3.1v1H68.25v1.58Zm.77,10.21H74v.89H68.08Zm0-1.79H74v.9H68.08Zm0-1.78H74v.89H68.08Zm0-1.79H74v.9H68.08Zm0-1.66H74v.89H68.08Zm0-1.78H74v.89H68.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 181.67,
    y: 64.75,
    width: 2.85,
    height: 8.89,
    transform: "translate(252.28 -113.9) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M178,55.69V75.34h10.23V55.69h-1.3V53.5h-1.69v.65H181V53.5h-1.69v2.19Zm7,3.24h-3.42V57.7H185Zm-2.49,1.23v1.23h-1.25V60.16Zm4.67-1.23h-1.25V57.7h1.25Zm0,2.46h-3.43V60.16h3.43ZM185,62.62v1.23h-1.25V62.62Zm2.18,1.23h-1.25V62.62h1.25ZM179,65.08h8.1V70H179Zm0-2.46h3.43v1.23H179Zm0-2.46h1.25v1.23H179Zm0-2.46h1.25v1.23H179Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "150.71 51.6 150.71 52.57 155.37 52.57 155.37 51.6 156.16 51.6 156.16 75.34 149.92 75.34 149.92 51.6 150.71 51.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 144.36,
    y: 63.06,
    width: 16.61,
    height: 0.75,
    transform: "translate(216.1 -89.23) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "154.54 71.75 155.29 71.75 155.29 55.13 154.54 55.13 153.79 55.13 153.79 71.75 154.54 71.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 142.86,
    y: 63.06,
    width: 16.61,
    height: 0.75,
    transform: "translate(214.61 -87.73) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M89,61.47V75.12a.22.22,0,0,0,.23.22H96.1a.22.22,0,0,0,.22-.22V54.92a.22.22,0,0,0-.38-.15l-6.87,6.55A.21.21,0,0,0,89,61.47Zm4.58,1.78h-.92v-.91h.92Zm0,2.12H90.83v-.9h2.75Zm0,2.13H91.75v-.9h1.83Zm0,2.13h-.92v-.91h.92Zm.91,1.22h.92v.9h-.92Zm0-2.13h.92v.91h-.92Zm0-2.12h.92v.9h-.92Zm0-2.13h.92v.9h-.92Zm0-2.13h.92v.91h-.92Zm-3.66,8.51h2.75v.9H90.83Zm-.91-2.13h1.83v.91H89.92Zm0-2.12h.91v.9h-.91Zm0-4.26h1.83v.91H89.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M101.34,43.5V74.62a.68.68,0,0,0,.63.72h9.54a.68.68,0,0,0,.63-.72V43.5a.68.68,0,0,0-.63-.72H102A.68.68,0,0,0,101.34,43.5Zm8.09,23.36h1.89v1.3h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.76h1.89v1.29h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.76h1.89v1.29h-1.89ZM107,66.86h1.89v1.3H107Zm0-2.77h1.89v1.3H107Zm0-2.76h1.89v1.29H107Zm0-2.77h1.89v1.3H107Zm0-2.77h1.89v1.3H107ZM107,53h1.89v1.3H107Zm0-2.77h1.89v1.3H107Zm0-2.76h1.89v1.29H107Zm-2.4,19.37h1.89v1.3h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.76h1.89v1.29h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.76h1.89v1.29h-1.89Zm-2.45,19.37h1.89v1.3h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.76h1.89v1.29h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.77h1.89v1.3h-1.89Zm0-2.76h1.89v1.29h-1.89Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 65.5,
    y1: 63.21,
    x2: 65.5,
    y2: 72.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M61,72.25v-.41s0,0,.08,0h5.13s.08,0,.08-.05v-.6s0-.06-.08-.06H61.06s-.08,0-.08,0v-.4s0,0,.08,0h5.13s.08,0,.08-.06v-.6s0,0-.08,0H61.06s-.08,0-.08-.05v-.4s0-.06.08-.06h5.13s.08,0,.08,0v-.6s0-.06-.08-.06H61.06s-.08,0-.08-.05v-.4s0,0,.08,0h5.13s.08,0,.08-.06v-.6s0,0-.08,0H61.06s-.08,0-.08,0V67s0-.06.08-.06h5.13s.08,0,.08-.05v-.6s0,0-.08,0H61.06s-.08,0-.08-.06v-.4s0,0,.08,0h5.13s.08,0,.08-.06v-.6s0,0-.08,0H61.06S61,65,61,65v-.4s0-.06.08-.06h5.13s.08,0,.08,0V64s0-.05-.08-.05H61.06s-.08,0-.08,0v-.41s0-.05.08-.05h5.13s.08,0,.08,0v-.5s0-.05-.08-.05H59.78c-.05,0-.08,0-.08.05V75.28s0,.06.08.06h6.41s.08,0,.08-.06V72.35s0,0-.08,0H61.06S61,72.28,61,72.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M136.42,47.55V74.71a.7.7,0,0,0,.74.63h11.17a.7.7,0,0,0,.74-.63V47.55a.69.69,0,0,0-.74-.63H137.16A.69.69,0,0,0,136.42,47.55Zm9.47,20.39h2.22v1.13h-2.22Zm0-2.42h2.22v1.14h-2.22Zm0-2.41h2.22v1.13h-2.22Zm0-2.42h2.22v1.13h-2.22Zm0-2.41h2.22v1.13h-2.22Zm0-2.42h2.22V57h-2.22Zm0-2.42h2.22v1.14h-2.22Zm0-2.41h2.22v1.13h-2.22Zm-2.81,16.91h2.21v1.13h-2.21Zm0-2.42h2.21v1.14h-2.21Zm0-2.41h2.21v1.13h-2.21Zm0-2.42h2.21v1.13h-2.21Zm0-2.41h2.21v1.13h-2.21Zm0-2.42h2.21V57h-2.21Zm0-2.42h2.21v1.14h-2.21Zm0-2.41h2.21v1.13h-2.21Zm-2.81,16.91h2.21v1.13h-2.21Zm0-2.42h2.21v1.14h-2.21Zm0-2.41h2.21v1.13h-2.21Zm0-2.42h2.21v1.13h-2.21Zm0-2.41h2.21v1.13h-2.21Zm0-2.42h2.21V57h-2.21Zm0-2.42h2.21v1.14h-2.21Zm0-2.41h2.21v1.13h-2.21Zm-2.88,16.91h2.21v1.13h-2.21Zm0-2.42h2.21v1.14h-2.21Zm0-2.41h2.21v1.13h-2.21Zm0-2.42h2.21v1.13h-2.21Zm0-2.41h2.21v1.13h-2.21Zm0-2.42h2.21V57h-2.21Zm0-2.42h2.21v1.14h-2.21Zm0-2.41h2.21v1.13h-2.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 167.62,
    y: 53.71,
    width: 6.06,
    height: 14.77,
    transform: "translate(341.29 122.18) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M167.49,53V75a.33.33,0,0,0,.3.35h5.71a.33.33,0,0,0,.31-.35V53a.33.33,0,0,0-.31-.34h-.14a2.63,2.63,0,0,0-1.13-2.1v-1a.06.06,0,0,0-.06-.06h-1.23l-.25-2.76s-.08,0-.08,0l-.26,2.76h-1.23a.06.06,0,0,0-.05.06v1a2.58,2.58,0,0,0-1.13,2.1h-.15A.32.32,0,0,0,167.49,53Zm.95,14.61h4.42v.75h-4.42Zm0-1.5h4.42v.75h-4.42Zm0-1.46h4.42v.75h-4.42Zm0-1.47h4.42v.75h-4.42Zm0-1.5h4.42v.75h-4.42Zm0-1.49h4.42v.75h-4.42Zm0-1.47h4.42v.75h-4.42Zm0-1.46h4.42V58h-4.42Zm0-1.5h4.42v.75h-4.42Zm0-1.5h4.42V55h-4.42Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 50.7,
    cy: 68.62,
    rx: 3.91,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 50.7,
    y1: 72.49,
    x2: 50.7,
    y2: 64.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 54.61,
    y1: 68.62,
    x2: 46.91,
    y2: 68.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 53.42,
    y1: 71.31,
    x2: 47.98,
    y2: 65.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 47.98,
    y1: 71.31,
    x2: 53.42,
    y2: 65.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.13,68.52c0-.16.29-.28.65-.28s.65.12.65.28h0v.78c0,.08,0,.14-.08.14H46.21c-.05,0-.08-.06-.08-.14v-.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 46.23,
    y: 68.53,
    width: 1.07,
    height: 0.48,
    rx: 0.16,
    transform: "translate(93.54 137.54) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.45,65.73c0-.15.29-.28.65-.28s.66.13.66.28v0s0,0,0,0v.75c0,.07,0,.13-.09.13H47.54s-.09-.06-.09-.13v-.75s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 47.56,
    y: 65.75,
    width: 1.07,
    height: 0.48,
    rx: 0.16,
    transform: "translate(96.19 131.98) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M50.05,64.44c0-.16.29-.28.65-.28s.65.12.65.28h0v.78c0,.08,0,.14-.08.14H50.13c-.05,0-.08-.06-.08-.14v-.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 50.15,
    y: 64.45,
    width: 1.07,
    height: 0.48,
    rx: 0.16,
    transform: "translate(101.38 129.38) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M52.71,65.66c0-.15.29-.28.66-.28s.65.13.65.28a0,0,0,0,1,0,0v.78c0,.07,0,.13-.09.13H52.8s-.09-.06-.09-.13v-.78A0,0,0,0,1,52.71,65.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 52.82,
    y: 65.68,
    width: 1.07,
    height: 0.48,
    rx: 0.16,
    transform: "translate(106.71 131.84) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M54,68.52c0-.16.29-.28.66-.28s.65.12.65.28h0s0,0,0,0v.75c0,.08,0,.14-.09.14H54s-.09-.06-.09-.14v-.75s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 54.06,
    y: 68.53,
    width: 1.07,
    height: 0.48,
    rx: 0.16,
    transform: "translate(109.19 137.54) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M48.26,70.11c.49.74,1,0,1,0s1.53-2.77,4.15-2.09a4,4,0,0,1,3,2.85v4.28a.19.19,0,0,1-.19.19H42.3a.2.2,0,0,1-.19-.19V71a.21.21,0,0,1,0-.11A4,4,0,0,1,48.26,70.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 85.55,
    y: 67.27,
    width: 2.25,
    height: 0.63,
    transform: "translate(173.36 135.18) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 82,
    y: 67.27,
    width: 2.25,
    height: 0.63,
    transform: "translate(166.26 135.18) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 78.39,
    y: 67.27,
    width: 2.25,
    height: 0.63,
    transform: "translate(159.03 135.18) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M8.63,50.64V74.9h1.51V72.17h.95V74.9h1.52V50.64H11.09v2h-.95v-2Zm2.46,2.93v1h-.95v-1Zm0,1.42V69.87h-.95V55Zm-.95,16.3v-1h.95v1Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 42.07,
    y1: 74.84,
    x2: -20.83,
    y2: 74.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M40.57,74.84s-19.47-4.73-28.76-21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M32.67,74.9A37.72,37.72,0,0,1,12,53.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M25.62,74.79s-9.45-4.74-14-21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M18.61,74.79s-4.75-4.74-7-21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M-19.41,74.76S.06,70,9.35,53.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M-11.51,74.81a37.72,37.72,0,0,0,20.64-21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M-4.46,74.72S5,70,9.5,53.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2.54,74.7s4.76-4.74,7-21"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M10.14,87.67v-1h.95v1h1.52V75.91H11.09v1.33h-.95V75.91H8.63V87.67Zm0-1.41v-.48h.95v.48Zm0-.69V78.35h.95v7.22Zm.95-7.91v.48h-.95v-.48Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 42.07,
    y1: 75.94,
    x2: -20.83,
    y2: 75.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M40.57,75.94s-19.47,2.3-28.76,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M32.67,75.91S18.69,78.2,12,86.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M25.62,76s-9.45,2.29-14,10.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M18.61,76s-4.75,2.29-7,10.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M-19.41,76S.06,78.28,9.35,86.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M-11.51,76s14,2.3,20.64,10.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M-4.46,76S5,78.29,9.5,86.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2.54,76s4.76,2.3,7,10.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88,80.39V75.82H85.28v4.57Zm-2.39-.85h2v.52h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.51,80.39V75.82H81.75v4.57Zm-2.38-.82h2v.52h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.89,80.39V75.82H78.14v4.57Zm-2.38-.82h2v.52h-2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.83,
    y: 75.82,
    width: 4.41,
    height: 1.17,
    transform: "translate(176.07 152.8) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 64.64,
    y: 76.23,
    width: 3.27,
    height: 0.8,
    transform: "translate(132.55 153.26) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.06,77.05l.91.6h2.34l1.17-.78V75.82H64.06Zm2.78-.63h1v.43h-1Zm-1.11,0v.43h-1v-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.35,77.05l.91.6H57.6l1.17-.78V75.82H54.35Zm2.77-.63h1.05v.43H57.12Zm-1.1,0v.43H55v-.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 57.32,
    y: 76.2,
    width: 2.92,
    height: 0.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58,77.22h1.81l.61-.28h0V75.82H57.11v1Zm1.24-.76H60v.23h-.74Zm-1.64,0h.74v.23h-.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 78.11,
    y: 70.5,
    width: 2.51,
    height: 13.91,
    transform: "translate(1.9 156.82) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M87.67,79.1V75.82H71.36V79.1Zm-8.37-.52H76.41v-.72H79.3Zm.42-.72h3v.72h-3Zm6.25.72H83.13v-.72H86Zm-12.91-.72H76v.72H73.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 60.46,
    y: 77.06,
    width: 5.04,
    height: 4.74,
    transform: "translate(125.96 158.85) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 95.41,
    y: 76.61,
    width: 6.56,
    height: 8.22,
    transform: "translate(197.38 161.44) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 110.88,
    y: 79.93,
    width: 9.34,
    height: 13.56,
    transform: "translate(231.1 173.42) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 132.55,
    y: 80.79,
    width: 5.62,
    height: 12.74,
    transform: "translate(270.72 174.32) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 154.79,
    y: 80.3,
    width: 5.84,
    height: 0.39,
    transform: "translate(315.43 160.99) rotate(-180)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 154.47,
    y: 80.23,
    width: 5.99,
    height: 0.07,
    transform: "translate(314.93 160.53) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 154.39,
    y: 82.37,
    width: 5.84,
    height: 0.39,
    transform: "translate(314.62 165.12) rotate(-180)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 154.07,
    y: 82.3,
    width: 5.99,
    height: 0.07,
    transform: "translate(314.12 164.66) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 173.44,
    y: 77.2,
    width: 5.2,
    height: 4.66,
    transform: "translate(352.09 159.05) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 184.96,
    y: 77.35,
    width: 6.76,
    height: 5.53,
    transform: "translate(376.68 160.23) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 163.19,
    y: 75.82,
    width: 4.66,
    height: 4.35,
    transform: "translate(331.05 155.99) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M162.83,80.09l4.71,2c.1,0,.26,0,.26,0V75.88s-.07-.06-.15-.06h-4.71c-.09,0-.16,0-.16.06V80S162.8,80.07,162.83,80.09Zm3.09-.32h-.63V79.5h.63Zm0-.64H164v-.28h1.88Zm0-.65h-1.25V78.2h1.25Zm0-.65h-.63v-.27h.63Zm.63-.92h.63v.27h-.63Zm0,.65h.63v.27h-.63Zm0,.64h.63v.28h-.63Zm0,.65h.63v.28h-.63Zm0,.65h.63v.27h-.63ZM164,76.91h1.88v.27H164Zm-.63.65h1.26v.27h-1.26Zm0,.64H164v.28h-.63Zm0,1.3h1.26v.27h-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M95.6,88.94l8.57-4.18a.12.12,0,0,0,.08-.09V76c0-.07-.12-.13-.28-.13H95.41c-.16,0-.28.06-.28.13v12.9C95.13,89,95.43,89,95.6,88.94ZM102,77h.91v7.42H102Zm-1.82,0h.91v7.42h-.91Zm-1.83,0h.91v7.42h-.91ZM96.5,77h.91v7.42H96.5Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 110.88,
    y1: 93.66,
    x2: 110.88,
    y2: 80.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.59,80.36V81s-.08.08-.17.08h-9.86c-.09,0-.16,0-.16.08V82s.07.07.16.07h9.86c.09,0,.17,0,.17.08v.59c0,.05-.08.08-.17.08h-9.86c-.09,0-.16,0-.16.08v.88s.07.08.16.08h9.86c.09,0,.17,0,.17.08v.59s-.08.08-.17.08h-9.86c-.09,0-.16,0-.16.08v.88s.07.08.16.08h9.86c.09,0,.17,0,.17.08v.59s-.08.08-.17.08h-9.86c-.09,0-.16,0-.16.07v.89s.07.08.16.08h9.86c.09,0,.17,0,.17.08v.59s-.08.07-.17.07h-9.86c-.09,0-.16,0-.16.08v.89s.07.08.16.08h9.86c.09,0,.17,0,.17.07v.59s-.08.08-.17.08h-9.86c-.09,0-.16,0-.16.08v.89s.07.07.16.07h9.86c.09,0,.17,0,.17.08v.59s-.08.08-.17.08h-9.86c-.09,0-.16,0-.16.08v.61s.07.08.16.08h9.86c.09,0,.17,0,.17.08v.59s-.08.08-.17.08h-9.86c-.09,0-.16,0-.16.08v.72s.07.08.16.08h12.33c.09,0,.16,0,.16-.08V75.89s-.07-.07-.16-.07H109.56c-.09,0-.16,0-.16.07v4.32s.07.08.16.08h9.86C119.51,80.29,119.59,80.32,119.59,80.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M131.77,94.46H132a2.09,2.09,0,0,0,1.37,1.73V97s0,0,.06,0h1.49l.31,2.26a.05.05,0,0,0,.1,0l.31-2.26h1.49a.06.06,0,0,0,.06,0v-.78a2.09,2.09,0,0,0,1.37-1.73h.18c.2,0,.37-.12.37-.28V76.1c0-.16-.17-.28-.37-.28h-6.92c-.2,0-.37.12-.37.28V94.18C131.4,94.34,131.57,94.46,131.77,94.46Zm.78-12.88h5.36v.62h-5.36Zm0,1.23h5.36v.62h-5.36Zm0,1.2h5.36v.62h-5.36Zm0,1.2h5.36v.62h-5.36Zm0,1.23h5.36v.62h-5.36Zm0,1.23h5.36v.62h-5.36Zm0,1.2h5.36v.62h-5.36Zm0,1.2h5.36v.62h-5.36Zm0,1.23h5.36v.62h-5.36Zm0,1.23h5.36v.62h-5.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "159.63 86.05 159.63 85.63 163.54 85.63 163.54 86.05 164.21 86.05 164.21 75.82 158.97 75.82 158.97 86.05 159.63 86.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 157.69,
    y: 80.62,
    width: 7.16,
    height: 0.63,
    transform: "translate(242.2 -80.34) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "162.85 84.51 163.47 84.51 163.47 77.35 162.85 77.35 162.22 77.35 162.22 84.51 162.85 84.51"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 156.43,
    y: 80.62,
    width: 7.16,
    height: 0.63,
    transform: "translate(240.94 -79.08) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M185.52,83.29v.83h1.22v.53h3.09v-.53h1.23v-.83H192V75.82h-7.42v7.47Zm-.17-5.82h5.87v.47h-5.87Zm0,.94h5.87v.46h-5.87Zm0,.93h5.87v.47h-5.87Zm0,.94h5.87v.47h-5.87Zm0,.87h5.87v.47h-5.87Zm0,.94h5.87v.46h-5.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M173.57,82.17v.71h.91v.45h2.33v-.45h.91v-.71h.71V75.82h-5.57v6.35Zm-.13-5h4.41v.4h-4.41Zm0,.8h4.41v.4h-4.41Zm0,.8h4.41v.39h-4.41Zm0,.79h4.41V80h-4.41Zm0,.74h4.41v.4h-4.41Zm0,.8h4.41v.4h-4.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 67.69,
    y: 77.24,
    width: 6.67,
    height: 5.35,
    transform: "translate(142.06 159.82) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 89.29,
    y: 77.24,
    width: 6.62,
    height: 5.18,
    transform: "translate(185.19 159.65) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 101.71,
    y: 78.93,
    width: 9.94,
    height: 11.66,
    transform: "translate(213.36 169.52) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 119.42,
    y: 78.65,
    width: 13.59,
    height: 11.68,
    transform: "translate(252.44 168.99) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 137.04,
    y: 78.6,
    width: 11.64,
    height: 10.05,
    transform: "translate(285.71 167.25) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 178.65,
    y: 81.08,
    width: 8.89,
    height: 3.57,
    transform: "translate(366.18 165.73) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M118.43,90.61c.11,2.74,1.66,4.92,3.56,4.92V90.69h0v4.84c6.29,0,11.42-2.18,11.79-4.92h0V75.91s-.09-.09-.21-.09H118.65c-.12,0-.22,0-.22.09V90.6h0ZM122,88h-1.84v-.9H122Zm2.77,1.78h-1.85v-.89h1.85ZM122.88,88v-.9h3.69V88Zm6.45,1.78h-3.68v-.89h3.68Zm0-1.78h-1.84v-.9h1.84Zm2.77,1.78h-1.85v-.89h1.85Zm0-1.78h-1.85v-.9h1.85Zm-12-8h12v.89h-12Zm0,1.78h12v.9h-12Zm0,1.79h12v.89h-12Zm0,1.79h12v.89h-12Zm0,3.57H122v.89h-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M68.25,82.86v.78h1.22v.5h3.1v-.5h1.22v-.78h.94v-7H67.31v7Zm-.17-5.49H74v.45H68.08Zm0,.89H74v.44H68.08Zm0,.88H74v.44H68.08Zm0,.88H74v.44H68.08Zm0,.82H74v.44H68.08Zm0,.88H74v.45H68.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 182.39,
    y: 74.41,
    width: 1.41,
    height: 8.89,
    transform: "translate(104.24 261.94) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M179.27,85.52v1.09H181v-.33h4.26v.33h1.69V85.52h1.3v-9.7H178v9.7Zm5.69-1h-3.42v-.61H185Zm-3.74-1.21v-.61h1.25v.61Zm5.92,1.21h-1.25v-.61h1.25Zm0-1.21h-3.43v-.61h3.43Zm-3.43-1.22v-.61H185v.61Zm3.43,0h-1.25v-.61h1.25ZM179,78.45h8.1v2.43H179Zm0,3h3.43v.61H179Zm0,1.22h1.25v.61H179Zm0,1.21h1.25v.61H179Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "150.71 87.54 150.71 87.06 155.37 87.06 155.37 87.54 156.16 87.54 156.16 75.82 149.92 75.82 149.92 87.54 150.71 87.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 148.56,
    y: 81.32,
    width: 8.21,
    height: 0.75,
    transform: "translate(70.97 234.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "154.54 77.59 155.29 77.59 155.29 85.8 154.54 85.8 153.79 85.8 153.79 77.59 154.54 77.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 147.06,
    y: 81.32,
    width: 8.21,
    height: 0.75,
    transform: "translate(69.47 232.86) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M89.07,82.74,95.94,86c.14.07.38,0,.38-.08v-10c0-.06-.1-.1-.22-.1H89.23c-.13,0-.23,0-.23.1v6.75S89,82.72,89.07,82.74Zm4.51-.5h-.92v-.45h.92Zm0-1H90.83v-.45h2.75Zm0-1H91.75v-.45h1.83Zm0-1.06h-.92v-.44h.92Zm.91-1.49h.92V78h-.92Zm0,1h.92v.44h-.92Zm0,1h.92v.45h-.92Zm0,1h.92v.45h-.92Zm0,1.05h.92v.45h-.92Zm-3.66-4.2h2.75V78H90.83Zm-.91,1h1.83v.44H89.92Zm0,1h.91v.45h-.91Zm0,2.1h1.83v.45H89.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M102,91.9h9.54c.35,0,.63-.16.63-.35V76.17c0-.19-.28-.35-.63-.35H102c-.35,0-.63.16-.63.35V91.55C101.34,91.74,101.62,91.9,102,91.9Zm7.46-12.54h1.89V80h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.36h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89ZM107,79.36h1.89V80H107Zm0,1.37h1.89v.64H107Zm0,1.37h1.89v.64H107Zm0,1.37h1.89v.64H107Zm0,1.36h1.89v.64H107Zm0,1.37h1.89v.64H107Zm0,1.37h1.89v.64H107Zm0,1.37h1.89v.64H107Zm-2.4-9.58h1.89V80h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.36h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89Zm-2.45-9.58h1.89V80h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.36h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89Zm0,1.37h1.89v.64h-1.89Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 65.5,
    y1: 81.81,
    x2: 65.5,
    y2: 77.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M61,77.34v.2s0,0,.08,0h5.13s.08,0,.08,0v.3s0,0-.08,0H61.06l-.08,0v.2s0,0,.08,0h5.13s.08,0,.08,0v.3s0,0-.08,0H61.06s-.08,0-.08,0v.2s0,0,.08,0h5.13s.08,0,.08,0v.3s0,0-.08,0H61.06s-.08,0-.08,0v.2s0,0,.08,0h5.13s.08,0,.08,0v.3s0,0-.08,0H61.06l-.08,0v.2s0,0,.08,0h5.13s.08,0,.08,0v.3s0,0-.08,0H61.06s-.08,0-.08,0v.2s0,0,.08,0h5.13s.08,0,.08,0v.3s0,0-.08,0H61.06l-.08,0v.2s0,0,.08,0h5.13s.08,0,.08,0v.2s0,0-.08,0H61.06s-.08,0-.08,0v.2s0,0,.08,0h5.13s.08,0,.08,0V82s0,0-.08,0H59.78c-.05,0-.08,0-.08,0V75.84s0,0,.08,0h6.41s.08,0,.08,0v1.45s0,0-.08,0H61.06S61,77.33,61,77.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M137.16,89.86h11.17c.41,0,.74-.14.74-.31V76.13c0-.17-.33-.31-.74-.31H137.16c-.41,0-.74.14-.74.31V89.55C136.42,89.72,136.75,89.86,137.16,89.86Zm8.73-11h2.22v.56h-2.22Zm0,1.2h2.22v.55h-2.22Zm0,1.19h2.22v.56h-2.22Zm0,1.19h2.22v.56h-2.22Zm0,1.2h2.22v.56h-2.22Zm0,1.19h2.22v.56h-2.22Zm0,1.19h2.22v.56h-2.22Zm0,1.2h2.22v.56h-2.22Zm-2.81-8.36h2.21v.56h-2.21Zm0,1.2h2.21v.55h-2.21Zm0,1.19h2.21v.56h-2.21Zm0,1.19h2.21v.56h-2.21Zm0,1.2h2.21v.56h-2.21Zm0,1.19h2.21v.56h-2.21Zm0,1.19h2.21v.56h-2.21Zm0,1.2h2.21v.56h-2.21Zm-2.81-8.36h2.21v.56h-2.21Zm0,1.2h2.21v.55h-2.21Zm0,1.19h2.21v.56h-2.21Zm0,1.19h2.21v.56h-2.21Zm0,1.2h2.21v.56h-2.21Zm0,1.19h2.21v.56h-2.21Zm0,1.19h2.21v.56h-2.21Zm0,1.2h2.21v.56h-2.21Zm-2.88-8.36h2.21v.56h-2.21Zm0,1.2h2.21v.55h-2.21Zm0,1.19h2.21v.56h-2.21Zm0,1.19h2.21v.56h-2.21Zm0,1.2h2.21v.56h-2.21Zm0,1.19h2.21v.56h-2.21Zm0,1.19h2.21v.56h-2.21Zm0,1.2h2.21v.56h-2.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.62,
    y: 79.21,
    width: 6.06,
    height: 7.3,
    transform: "translate(341.29 165.71) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M167.79,87.05h.15c0,.42.45.8,1.13,1v.48s0,0,.05,0h1.23l.26,1.36s.07,0,.08,0l.25-1.36h1.23s.06,0,.06,0v-.48c.67-.23,1.11-.61,1.13-1h.14c.17,0,.31-.08.31-.17V76c0-.09-.14-.16-.31-.16h-5.71c-.17,0-.3.07-.3.16v10.9C167.49,87,167.62,87.05,167.79,87.05Zm.65-7.76h4.42v.37h-4.42Zm0,.74h4.42v.37h-4.42Zm0,.72h4.42v.37h-4.42Zm0,.73h4.42v.37h-4.42Zm0,.74h4.42v.37h-4.42Zm0,.74h4.42v.37h-4.42Zm0,.72h4.42v.37h-4.42Zm0,.72h4.42v.37h-4.42Zm0,.74h4.42v.37h-4.42Zm0,.74h4.42v.37h-4.42Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 50.7,
    cy: 79.13,
    rx: 3.91,
    ry: 1.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 50.7,
    y1: 77.22,
    x2: 50.7,
    y2: 81.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 54.61,
    y1: 79.13,
    x2: 46.91,
    y2: 79.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 53.42,
    y1: 77.8,
    x2: 47.98,
    y2: 80.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 47.98,
    y1: 77.8,
    x2: 53.42,
    y2: 80.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.13,79.19c0,.07.29.13.65.13s.65-.06.65-.13h0v-.39s0-.06-.08-.06H46.21c-.05,0-.08,0-.08.06v.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 46.23,
    y: 78.94,
    width: 1.07,
    height: 0.24,
    rx: 0.11,
    transform: "translate(93.54 158.12) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.45,80.56c0,.08.29.14.65.14s.66-.06.66-.14h0v-.37a.08.08,0,0,0-.09-.07H47.54a.08.08,0,0,0-.09.07v.37h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 47.56,
    y: 80.32,
    width: 1.07,
    height: 0.24,
    rx: 0.11,
    transform: "translate(96.19 160.87) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M50.05,81.2c0,.08.29.14.65.14s.65-.06.65-.14h0v-.37a.08.08,0,0,0-.08-.07H50.13a.07.07,0,0,0-.08.07v.37h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 50.15,
    y: 80.96,
    width: 1.07,
    height: 0.24,
    rx: 0.11,
    transform: "translate(101.38 162.15) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M52.71,80.6c0,.07.29.13.66.13s.65-.06.65-.13h0s0,0,0,0V80.2s0-.06-.09-.06H52.8s-.09,0-.09.06v.37s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 52.82,
    y: 80.35,
    width: 1.07,
    height: 0.24,
    rx: 0.11,
    transform: "translate(106.71 160.94) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M54,79.19c0,.07.29.13.66.13s.65-.06.65-.13h0s0,0,0,0v-.37s0-.06-.09-.06H54s-.09,0-.09.06v.37s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 54.06,
    y: 78.94,
    width: 1.07,
    height: 0.24,
    rx: 0.11,
    transform: "translate(109.19 158.12) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M48.26,78.4a.83.83,0,0,1,1,0,5.42,5.42,0,0,0,4.15,1c2.49-.32,3-1.3,3-1.41V75.91s-.08-.09-.19-.09H42.3c-.1,0-.19,0-.19.09V78s0,0,0,.06C44.32,79.6,47.77,78.76,48.26,78.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 85.55,
    y: 79.49,
    width: 2.25,
    height: 0.31,
    transform: "translate(173.36 159.29) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 82,
    y: 79.49,
    width: 2.25,
    height: 0.31,
    transform: "translate(166.26 159.29) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 78.39,
    y: 79.49,
    width: 2.25,
    height: 0.31,
    transform: "translate(159.03 159.29) rotate(-180)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 191.95,
    y1: 75.34,
    x2: -0.05,
    y2: 75.34
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/BG_1.cd4c5f381a98bcdaa95c606cbb0882eb.svg";
export { ForwardRef as ReactComponent };